import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Icon } from "@circleco/compass/components/Icon";
import { Typography } from "@circleco/compass/components/Typography";
import type { DropzoneInputProps, DropzoneRootProps } from "react-dropzone";

import { t } from "@/i18n-js/instance";

import { MAX_IMAGES } from "./hooks/useMultiImageUpload";

interface MultiImageDropZoneProps {
  className?: string;
  getInputProps: () => DropzoneInputProps;
  getRootProps: () => DropzoneRootProps;
  isDragActive: boolean;
  open: () => void;
}

export const MultiImageDropZone = ({
  isDragActive,
  getRootProps,
  getInputProps,
  open,
  className,
}: MultiImageDropZoneProps) => {
  const title = t(
    "image_space.post_modal.steps.upload_images.drag_and_drop_up_to_n_images",
    {
      max_images: MAX_IMAGES,
    },
  );

  return (
    <div {...getRootProps()} className="group flex min-h-0 flex-1 size-full">
      <button
        type="button"
        className={classNames(
          "border-primary flex p-6 flex-1 flex-col items-center justify-center rounded-xl border border-dashed text-center",
          { "bg-secondary": isDragActive },
          className,
        )}
        onClick={open}
      >
        <input {...getInputProps()} data-testid="upload_multi_image" />
        <div className="bg-secondary mb-4 flex size-11 items-center justify-center rounded-full">
          <Icon name="arrow-box-up" size="sm" />
        </div>
        <Typography variant="label-md" color="primary">
          {title}
        </Typography>
        <div className="mt-1">
          <Typography variant="body-sm" color="tertiary">
            {t("image_space.post_modal.steps.upload_images.recommendation")}
          </Typography>
        </div>
      </button>
    </div>
  );
};
